import React from 'react';
import { Box, Container } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

const FullLoading = (): JSX.Element => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 1,
        height: '100vh',
      }}>
      <CircularProgress />
    </Box>
  );
};

export default FullLoading;
